import React from 'react';
//import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
// import { fetchShopifyProfile } from '../../store/reducers/createProfile/apithunk';
// import { ToastNotifyError, ToastNotifySuccess } from '../../components/CommonComponents/Toast/ToastNotify';
// import { updateLoading } from '../../store/reducers/loader';
// import rollbar from '../../rollbarConfig';
// import TextFeild from '../../components/CommonComponents/TextFeild';
import { BUTTON_LABELS } from '../../constants/lang';
//import { useNavigate } from 'react-router-dom';

const CreateSopify = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [storeName, setStoreName] = useState('');

  const handleSaveProduct = async () => {
    // if (!storeName.trim()) {
    //   ToastNotifyError('Please enter store name');
    //   return;
    // }

    // dispatch(updateLoading(true));
    // try {
    //   const res = await dispatch(fetchShopifyProfile(`?shop=${storeName}`));
    //   const { success, message, auth_url } = res?.payload;
    //   if (success) {
    //     if (auth_url) {
    //       window.location.href = auth_url;
    //     } else {
    //       ToastNotifySuccess(message);
    //     }
    //   } else if (res.payload.response.data.message === "You already have an active Shopify connection") {
    //     navigate("/create-profile/shopify-list");
    //   } else {
    //     ToastNotifyError(message);
    //   }
    // } catch (error) {
    //   rollbar.error("Error in Shopify profile fetch:", error);
    //   console.error("Shopify profile fetch failed:", error);
    //   ToastNotifyError('Failed to connect Shopify store');
    // } finally {
    //   dispatch(updateLoading(false));
    // }
    
    // Redirect to Shopify App Store search for Wanderobe
    window.open('https://apps.shopify.com/wanderobe', '_self');
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography 
        sx={{ 
          fontFamily: 'Lexend',
          fontSize: 20,
          fontWeight: 400,
          color: '#0F0F0F',
          mb: 2
        }}
      >
        Shopify Account
      </Typography>
{/*       
      <Box className='text-feilds'>
        <TextFeild
          id='storeName'
          required
          label="Store Name"
          placeholder='Enter store name'
          variant='outlined'
          fullWidth
          margin='normal'
          value={storeName}
          onChange={(e) => setStoreName(e.target.value)}
        />
      </Box> */}

      <Button
        type='submit'
        variant='contained'
        color='primary'
        aria-label='submit-btn'
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          handleSaveProduct();
        }}
        sx={{
          width: '100%',
          padding: '9px',
          marginTop: '80px',
          fontSize: '16px',
          fontWeight: 400,
          textTransform: 'none',
          fontFamily: 'Lexend',
        }}
      >
        {BUTTON_LABELS.CONNECT_SHOPIFY}
      </Button>
    </Box>
  );
};

export default CreateSopify;